export default "__VITE_ASSET__192d3f94__"